import { Button, type ButtonProps } from '@olxeu-jobs/ui';
import { forwardRef } from 'react';

export const PlusButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ $style, ...props }, ref) => (
    <Button
      ref={ref}
      kind="tertiary"
      size="small"
      $style={{
        '::before': { content: '"+"', marginRight: '.25em' },
        ...$style,
      }}
      {...props}
    />
  ),
);
